import React, { useEffect, useState, useCallback } from "react";
import { BootstrapInput } from "../../../Utilities/utility";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Button,
  Box,
  IconButton,
  //Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import {
  getNonStdMLFBData,
  getCategory,
  getSubCategory,
  getZCode,
  getDeviation,
  deleteNonStandarsMLFB,
  SearchGetNonStandardMLFB,
  createNonStandardMLFB,
  editNonStandardMLFB,
} from "../../../redux/API/api_nonStandardMlfb";

const NonStandardMLFBDialog = React.memo(
  ({ open, onClose, onSave, onUpdate, nonstdToEdit }) => {
    const [error, setError] = useState("");
    const [category, setCategory] = useState([]);
    const [categoryId, setCategoryId] = useState("");
    const [subCategory, setSubCategory] = useState([]);
    const [subCategoryId, setSubCategoryId] = useState("");
    const [zCode, setZCode] = useState([]);
    const [ZCodeValue, setZcodeValue] = useState("");
    const [deviation, setDeviation] = useState("");
    const [zCodeId, setZCodeId] = useState("");
    const [deviationType, setDeviationType] = useState([]);
    const [deviationId, setDeviationId] = useState("");
    const [isLoader, setIsLoader] = useState(false);
    const UID = useSelector((state) => state.saveUserIdReducer);
    const userdetails = useSelector(
      (state) => state.storeUserDetailsReducer.userData
    );
    const zcodesResponse = useSelector(
      (state) => state.storeZCodesResponseReducer
    );
    const [errors, setErrors] = useState({});
    const siteToken = useSelector((state) => state.saveTokenReducer);
    const azureToken = useSelector((state) => state.saveAzureTokenReducer);
    const [parentCategoryId, setParentCategoryId] = useState("");
    const [categoryName, setCategoryName] = useState("");
    const [formData, setFormData] = useState({
      categoryId: "",
      categoryName: "",
      subcatparentid: "",
      subCategory: "",
      subCategoryId: "",
      subCategoryName: "",
      subCategorysName:"",
      ZCodeValue: "",
      subcatparentid: "",
      Deviation: "",
      DeviationType: "",
      DeviationTypeName: "",
      deviationTypeIdChosen:"",
      DeviationTypeId: "",
      ZcodeId: "",
      Zcode: "",
      ZcodeName: "",
    });

    useEffect(() => {

      getCategoryDropDownValue();
    
      if (
        nonstdToEdit &&
        nonstdToEdit.editNonStdMlfb &&
        nonstdToEdit.editNonStdMlfb.categoryId
      ) {
        //getCategoryDropDownValue(nonstdToEdit?.editNonStdMlfb?.categoryChosen);
        categoryDropdownChange(nonstdToEdit.editNonStdMlfb.categoryChosen);
        zCodeDropdownChange(nonstdToEdit.editNonStdMlfb.zcodeIdChosen);
        subCategorydropdownChange(
          nonstdToEdit.editNonStdMlfb.subCategoryChosen
        );
        // getSubCategoryDropDownValue(nonstdToEdit?.editNonStdMlfb?.subCategoryChosen);
        deviationDropdownChange(
          nonstdToEdit?.editNonStdMlfb?.deviationTypeIdChosen
        );
       
        getZcodeDropDownValue(nonstdToEdit?.editNonStdMlfb?.subCategoryChosen);
        getDeviationDropDownValue();
      }
     

      setFormData({
        categoryId: nonstdToEdit?.editNonStdMlfb?.categoryId || 0,
        categoryName: nonstdToEdit?.editNonStdMlfb?.category || "",
        subCategorysName: nonstdToEdit?.editNonStdMlfb?.subCategoryName || "",
        subCategoryId: nonstdToEdit?.editNonStdMlfb?.subcatoryid || "",
        subCategory: nonstdToEdit?.editNonStdMlfb?.subCategory || "",
        ZCodeValue: nonstdToEdit?.editNonStdMlfb?.zCodeValue || "",
        subcatparentid: nonstdToEdit?.editNonStdMlfb?.subcatparentid || "",
        Deviation: nonstdToEdit?.editNonStdMlfb?.deviation || "",
        DeviationType: nonstdToEdit?.editNonStdMlfb?.deviationType || "",
        DeviationTypeName:
          nonstdToEdit?.editNonStdMlfb?.DeviationTypeName || "",
        Zcode: nonstdToEdit?.editNonStdMlfb?.zcode || "",
        ZcodeId: zCodeId || "",
        ZcodeName: nonstdToEdit?.editNonStdMlfb?.zCodeValue || "",
        categoryChosen: nonstdToEdit?.editNonStdMlfb?.categoryChosen || "",
        subCategoryChosen:
          nonstdToEdit?.editNonStdMlfb?.subCategoryChosen || "",
        zcodeIdChosen: nonstdToEdit?.editNonStdMlfb?.zcodeIdChosen || "",
        deviationTypeIdChosen:
          nonstdToEdit?.editNonStdMlfb?.deviationTypeIdChosen || "",
      });
      setCategory([]);
      setSubCategory([]);
      setZCode([]);
      setDeviationType([]);
      setErrors({});
    }, [nonstdToEdit]);

    function getCategoryDropDownValue() {
      setIsLoader(true);
      getCategory(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId
      )
        .then((response) => {
          console.log("category", response);
          setCategory(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }

    function getSubCategoryDropDownValue(categoryId) {
      setIsLoader(true);
      getSubCategory(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        categoryId
      )
        .then((response) => {
          console.log("Subcategory", response);
          setSubCategory(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }

    function getZcodeDropDownValue(subCategorypPartId) {
      setIsLoader(true);
      getZCode(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId,
        subCategorypPartId
      )
        .then((response) => {
          console.log("z-code", response);
          setZCode(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }
    function getDeviationDropDownValue() {
      setIsLoader(true);
      getDeviation(
        siteToken,
        azureToken.token,
        UID.id,
        userdetails.userEmail,
        userdetails.gid,
        userdetails.roleName,
        userdetails.roleId
      )
        .then((response) => {
          console.log("deviation", response);
          setDeviationType(response);
          setIsLoader(false);
        })
        .catch((error) => {
          console.log("Error: " + error, "error");
          setIsLoader(false);
        });
    }

    const categoryDropdownChange = (e) => {
      const categoryId = e;
      setCategoryId(categoryId);
      if (category?.length > 0) {
        const selectObject = category.find(
          (item) => item.categoryId === categoryId
        );
        if (!selectObject) {
          console.error(
            `non matching catogary found for matching id:${categoryId}`
          );
          return;
        }
        setFormData({
          ...formData,
          categoryId: categoryId,
          categoryName: selectObject.categoryName || "",
          categoryChosen: categoryId,
        });
        setCategoryName(categoryName);
        
      }
      setSubCategory([]);
      setZCode([]);
     
      setErrors({});
      getSubCategoryDropDownValue(categoryId);
      //setDeviationType([]);
    };

    const subCategorydropdownChange = (e) => {
      const subCategoryId = e;

      if (subCategory?.length > 0) {
        const selectObject = subCategory.find(
          (item) => item.subcatparentid === parseInt(subCategoryId)
        );

        if (selectObject) {
          console.log("Selected Object:", selectObject);

          setParentCategoryId(selectObject.subcatparentid);
          setFormData({
            ...formData,
            subCategoryId: subCategoryId,
            subCategorysName: selectObject.categoryName,
            subCategoryChosen: subCategoryId,
          });
          setErrors({});
          getZcodeDropDownValue(selectObject.subcatparentid);
        }
      }
    };

    const zCodeDropdownChange = (e) => {
      const zCodeId = e;
      if (zCode?.length > 0) {
        const selectObject = zCode.find((item) => item.zcodeid === zCodeId);

        if (!selectObject) {
          console.error(`non matching zcode found for matching id:${zCodeId}`);
          return;
        }
        setFormData({
          ...formData,
          Zcode: zCodeId,
          ZcodeId: e,
          ZcodeName: selectObject.zcode || "",
          zcodeIdChosen: zCodeId,
        });
      }
      setErrors({});
      setZCodeId(zCodeId);
      getDeviationDropDownValue();
    };

    const deviationDropdownChange = (e) => {
      const deviationId = e;
      setDeviationId(deviationId);

      if (deviationType?.length > 0) {
        const selectObject = deviationType.find(
          (item) => item.deviation == deviationId
        );

        if (selectObject) {
          console.log("Selected Object:", selectObject);

          setParentCategoryId(selectObject.subcatparentid);
          setFormData({
            ...formData,
            DeviationTypeId: String(deviationId),
            deviationTypeIdChosen: deviationId,
            DeviationType:deviationId,
            DeviationTypeName: selectObject.deviationType || "",
          });
        }
      }
      setErrors({});
    };

    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
      setError("");
      setErrors({});
    };

    const handleSave = (e) => {
      const deviationPattern = /^\d+(?:\.\d{0,2})?$/;
      const newError = {};
      setErrors({});
      if (!formData.categoryName && !nonstdToEdit?.editNonStdMlfb) {
        newError.categoryName = "Category is required !!";
      }

      if (!formData.subCategorysName && !nonstdToEdit?.editNonStdMlfb) {
        newError.subCategorysName = "Sub Category is required !!";
      }

      if (!formData.ZcodeName && !nonstdToEdit?.editNonStdMlfb) {
        newError.ZcodeName = "Z code is required !!";
      }

      if (!formData.Deviation) {
        newError.Deviation = "Deviation is required !!";
      }

      if ((!formData.DeviationTypeName && ! formData.DeviationType) || (formData.DeviationTypeName =="" && formData.DeviationType=="" )) {
        newError.DeviationTypeName = "Deviation Type is required !!";
      }

      if (!formData.ZCodeValue && !nonstdToEdit?.editNonStdMlfb) {
        newError.ZCodeValue = "Z Code description is required !!";
      }

      if (formData.Deviation && !deviationPattern.test(formData.Deviation)) {
        newError.Deviation =
          "Enter the number only with up to two decimal places allowed";
      }
      if (Object.keys(newError).length > 0) {
        setErrors(newError);
        return;
      } else if (nonstdToEdit?.editNonStdMlfb) {
        onUpdate(formData);
      } else {
        onSave(formData);
      }
    };

    return (
      <>
        <Dialog
          disableEnforceFocus
          disableAutoFocus
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="md"
          sx={{
            "& .MuiDialog-paper": {
              width: "70%",
              minWidth: 500,
              maxWidth: "90vw",
              height: "auto",
              maxHeight: "110vh",
              padding: 2,
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {nonstdToEdit?.editNonStdMlfb
              ? "Update Non Standard MLFB"
              : "Create Non Standard MLFB"}
            <IconButton
              onClick={onClose}
              style={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Box sx={{ minWidth: "48%" }}>
                <Typography
                  style={{ mb: 1, fontWeight: "bold", padding: "10px" }}
                >
                  Category<span style={{ color: "red" }}>*</span>
                </Typography>
                <span>
                  <Select
                    fullWidth
                    id="categoryId"
                    name="categoryName"
                    disabled={nonstdToEdit?.editNonStdMlfb}
                    value={
                      nonstdToEdit?.editNonStdMlfb
                        ? formData.categoryChosen
                        : formData.categoryId
                    }
                    onChange={(e) => categoryDropdownChange(e.target.value)}
                    displayEmpty
                    input={<BootstrapInput />}
                  >
                    {/* {nonstdToEdit?.editNonStdMlfb ? (
                    zcodesResponse?.menuItems?.length > 0 ? (
                      zcodesResponse?.menuItems.map((item) => (
                        <MenuItem key={item.categoryChosen} value={item.categoryChosen}>
                          {item.category}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Loading ZCode...</MenuItem>
                    )
                  ) : */}
                    {category?.length > 0 ? (
                      category.map((data) => (
                        <MenuItem key={data.categoryId} value={data.categoryId}>
                          {data.categoryName}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Loading Categories...</MenuItem>
                    )}
                  </Select>
                  {errors?.categoryName && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.categoryName}
                    </Typography>
                  )}
                </span>

                <Typography
                  style={{ mb: 1, fontWeight: "bold", padding: "10px" }}
                >
                  Z-code <span style={{ color: "red" }}>*</span>
                </Typography>
                <span>
                  <Select
                    fullWidth
                    id="zCodeId"
                    name="ZcodeName"
                    disabled={nonstdToEdit?.editNonStdMlfb}
                    displayEmpty
                    value={
                      nonstdToEdit?.editNonStdMlfb
                        ? formData.zcodeIdChosen
                        : formData.Zcode
                    }
                    onChange={(e) => zCodeDropdownChange(e.target.value)}
                    input={<BootstrapInput />}
                  >
                    {/* {nonstdToEdit?.editNonStdMlfb ? (
                    zcodesResponse?.menuItems?.length > 0 ? (
                      zcodesResponse?.menuItems.map((item) => (
                        <MenuItem key={item.zcodeIdChosen} value={item.zcodeIdChosen}>
                          {item.zcode}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Loading ZCode...</MenuItem>
                    )
                  ) :  */}
                    {zCode?.length > 0 ? (
                      zCode?.map((data) => (
                        <MenuItem key={data.zcodeid} value={data.zcodeid}>
                          {data.zcode}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Loading ZCode...</MenuItem>
                    )}
                  </Select>

                  {errors?.ZcodeName && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.ZcodeName}
                    </Typography>
                  )}
                </span>

                <Typography
                  style={{ mb: 1, fontWeight: "bold", padding: "10px" }}
                >
                  Deviation Type <span style={{ color: "red" }}>*</span>
                </Typography>
                <span>
                <Select
                  fullWidth
                  id="deviationId"
                  name="DeviationType"
                  displayEmpty
                  value={
                    nonstdToEdit?.editNonStdMlfb
                      ? formData.deviationTypeIdChosen
                      : formData.DeviationTypeId
                  }
                  onChange={(e) => deviationDropdownChange(e.target.value)}
                  input={<BootstrapInput />}
                  sx={{
                    "& .MuiMenu-paper": {
                      //bgcolor:"rgba(173,216,230,0.8)"
                    },
                  }}
                >
                  
                  {deviationType?.length > 0 ? (
                    deviationType?.map((data) => (
                      <MenuItem key={data.deviation} value={data.deviation}>
                        {data.deviationType}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>Loading Deviation...</MenuItem>
                  )}
                </Select>
                {errors?.DeviationTypeName && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.DeviationTypeName}
                    </Typography>
                  )}
                </span>
              </Box>
              <Box sx={{ minWidth: "48%" }}>
                <Typography
                  style={{ mb: 1, fontWeight: "bold", padding: "10px" }}
                >
                  Sub Category <span style={{ color: "red" }}>*</span>
                </Typography>
                <span>
                <Select
                  fullWidth
                  disabled={nonstdToEdit?.editNonStdMlfb}
                  id="subCategoryId"
                  name="subCategoryName"
                  value={
                    nonstdToEdit?.editNonStdMlfb
                      ? formData.subCategoryChosen
                      : formData.subCategoryId
                  }
                  onChange={(e) => subCategorydropdownChange(e.target.value)}
                  displayEmpty
                  input={<BootstrapInput />}
                >
                  {/* {nonstdToEdit?.editNonStdMlfb ? (
                    zcodesResponse?.menuItems?.length > 0 ? (
                      zcodesResponse?.menuItems.map((item) => (
                        <MenuItem key={item.subCategoryChosen} value={item.subCategoryChosen}>
                          {item.subCategory}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>Loading ZCode...</MenuItem>
                    )
                  ) : */}
                  {subCategory?.length > 0 ? (
                    subCategory
                      .filter((data) => data.subcatparentid) // Filter based on subcatparentid
                      .map((data) => (
                        <MenuItem
                          key={data.subcatparentid}
                          value={data.subcatparentid}
                        >
                          {data.categoryName}
                        </MenuItem>
                      ))
                  ) : (
                    <MenuItem disabled>Loading Sub Category...</MenuItem>
                  )}
                </Select>
                {errors?.subCategorysName && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.subCategorysName}
                    </Typography>
                  )}
                </span>
                <Box sx={{ minWidth: "48%", padding: "10px" }}>
                  <span>
                  <TextField
                    disabled={nonstdToEdit?.editNonStdMlfb}
                    label="Z-Code description"
                    name="ZCodeValue"
                    variant="standard"
                    value={formData.ZCodeValue}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{
                      minWidth: "50%",
                      padding: "15px",
                      "& .MuiFormLabel-asterisk": { color: "red" },
                    }}
                  />
                   {errors?.ZCodeValue && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.ZCodeValue}
                    </Typography>
                  )}
                </span>
                </Box>
                <Box sx={{ padding: "10px" }}>
                  <span>
                  <TextField
                    label="Deviation"
                    name="Deviation"
                    variant="standard"
                    value={formData.Deviation}
                    onChange={handleChange}
                    fullWidth
                    required
                    sx={{
                      minWidth: "50%",
                      padding: "15px",
                      "& .MuiFormLabel-asterisk": { color: "red" },
                    }}
                  />
                   {errors?.Deviation && (
                    <Typography color="error" sx={{ textAlign: "center" }}>
                      {errors?.Deviation}
                    </Typography>
                  )}
                </span>

                </Box>
              </Box>
            </Box>
            {/* {error && (
            <Typography color="error" sx={{ mt: 2, textAlign: "center" }}>
              {error}
            </Typography>
          )} */}
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
            <Button
              className="btn"
              onClick={handleSave}
              variant="contained"
              color="primary"
              sx={{
                width: "120px",
                ml: 2,
                fontFamily: "SiemensSans-Bold, sans-serif",
                backgroundColor: "#008aa6",
              }}
            >
              {nonstdToEdit?.editNonStdMlfb ? "Update" : "Submit"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
);
export default NonStandardMLFBDialog;
